const rss = {
  title: "עדכוני RSS",
  description: "חדשות נדל\"ן ובנייה מישראל",
  feeds: "פידים",
  articles: "כתבות",
  unread: "לא נקראו",
  starred: "מסומנים",
  allArticles: "כל הכתבות",
  addFeed: "הוסף פיד",
  feedUrl: "כתובת RSS",
  feedTitle: "שם הפיד",
  keywords: "מילות מפתח",
  keywordsPlaceholder: "נדל\"ן, בנייה, קבלן...",
  syncNow: "סנכרן עכשיו",
  syncing: "מסנכרן...",
  lastSynced: "סנכרון אחרון",
  never: "טרם סונכרן",
  activeFeeds: "פידים פעילים",
  totalArticles: "סה\"כ כתבות",
  unreadCount: "לא נקראו",
  markRead: "סמן כנקרא",
  markAllRead: "סמן הכל כנקרא",
  viewAll: "הצג הכל",
  openArticle: "פתח כתבה",
  noArticles: "אין כתבות עדיין — הרץ סנכרון",
  noFeeds: "אין פידים פעילים",
  removeFeed: "הסר פיד",
  defaultFeed: "פיד ברירת מחדל",
  customFeed: "פיד מותאם",
  error: "שגיאה",
  synced: "מסונכרן",
  stale: "לא עדכני",
  matchedKeywords: "מילות מפתח תואמות",
  filterByFeed: "סנן לפי פיד",
  filterAll: "הכל",
  ago: "לפני",
  minutes: "דקות",
  hours: "שעות",
  days: "ימים",
  today: "היום",
  yesterday: "אתמול",
} as const;
export default rss;
